import { render, staticRenderFns } from "./ModalItemEdit.vue?vue&type=template&id=3c1520cc&scoped=true"
import script from "./ModalItemEdit.vue?vue&type=script&lang=js"
export * from "./ModalItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalItemEdit.vue?vue&type=style&index=0&id=3c1520cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1520cc",
  null
  
)

export default component.exports